/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  util.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H175591
 *
 * @Date         : Mar 24, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 * By            : E844276
 * On            : Aug 04, 2020
 * Description   : Removed accountType and OEM parameters for custom pricing
******************************************************************************/

import {UserAccountInformation} from './checkout-interfaces';
import { constructUserSessionObj, UserSessionInf } from '../../../utils/util';
import { logInfo } from '../../../utils/console-utility';

/**
 * @author H175591
 * @description This method retrieves the values stored in the browser local storage.
 */
export function constructUserAccountInfoObj(resp): UserAccountInformation {
    const userAccountObj: UserAccountInformation = {
        accountId: resp.accountId,
        customerName: resp.customerName,
        addressId:resp.addressId,
        sapNumber: resp.sapNumber,
        addrLine1: resp.addrLine1,
        addrLine2: resp.addrLine2,
        addrLine3: resp.addrLine3,
        country: resp.country,
        countryCode: resp.countryCode,
        state: resp.state,
        stateCode: resp.stateCode,
        city: resp.city,
        zip: resp.zip,
    }
    return userAccountObj;
}
export function getForgeTokenInfo (parameter: string) {
  /**
   * APU Phase 3 - Pen testing fix - To remove access token from local storage
   */
    // let localStoreSessionObj: any = localStorage.getItem('checkoutInLocalStorage');
    // let localStorageValuesObj: UserSessionInf;
    // if (localStoreSessionObj != null) {
    //     let jsonStr = JSON.parse(localStoreSessionObj);
    //     localStorageValuesObj = constructUserSessionObj(jsonStr);
    //     if (parameter === 'id_token') {
    //       return localStorageValuesObj.id_token;
    //     } else if (parameter === 'refresh_token') {
    //       return localStorageValuesObj.refresh_token;
    //     } else {
    //        return "";
    //     }
    // }
    // return "";
    let sessionStoreSessionObj: any = sessionStorage.getItem('checkoutInLocalStorage');
    let sessionStorageValuesObj: UserSessionInf;
    if (sessionStoreSessionObj != null) {
        let jsonStr = JSON.parse(sessionStoreSessionObj);
        sessionStorageValuesObj = constructUserSessionObj(jsonStr);
        if (parameter === 'id_token') {
          return sessionStorageValuesObj.id_token;
        } else if (parameter === 'refresh_token') {
          return sessionStorageValuesObj.refresh_token;
        } else {
           return "";
        }
    }
    return "";
}
export function updateForgeTokenInfo (accessToken: string, refreshToken: string) {
   /**
   * APU Phase 3 - Pen testing fix - To remove access token from local storage
   */
  // let localStoreSessionObj: any = localStorage.getItem('checkoutInLocalStorage');
  // let localStorageValuesObj: UserSessionInf;
  // if (localStoreSessionObj != null) {
  //     let jsonStr = JSON.parse(localStoreSessionObj);
  //     localStorageValuesObj = constructUserSessionObj(jsonStr);
  //     localStorageValuesObj.access_token = accessToken;
  //     localStorageValuesObj.refresh_token = refreshToken;
  //     jsonStr = JSON.stringify(localStorageValuesObj);
  //     logInfo('browser hash values response', jsonStr);
  //     // Storing the parameters to the browsers local store.
  //     localStorage.setItem('checkoutInLocalStorage', jsonStr);
  // }
  // return null;

  let sessionStoreSessionObj: any = sessionStorage.getItem('checkoutInLocalStorage');
  let sessionStorageValuesObj: UserSessionInf;
  if (sessionStoreSessionObj != null) {
      let jsonStr = JSON.parse(sessionStoreSessionObj);
      sessionStorageValuesObj = constructUserSessionObj(jsonStr);
      sessionStorageValuesObj.access_token = accessToken;
      sessionStorageValuesObj.refresh_token = refreshToken;
      jsonStr = JSON.stringify(sessionStorageValuesObj);
      logInfo('browser hash values response', jsonStr);
      // Storing the parameters to the browsers local store.
      sessionStorage.setItem('checkoutInLocalStorage', jsonStr);
  }
  return null;
}